// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddOrHideTokenModal_modal__2FePN","closeButton":"AddOrHideTokenModal_closeButton__37unq","body":"AddOrHideTokenModal_body__kaVpF"};